import React from "react";
import {
    Filters,
    Card,
    IndexTable,
    SkeletonBodyText,
    SkeletonDisplayText,
} from "@shopify/polaris";

export default function PlaceTableSkeleton(props) {
    const { headings } = props;
    return (
        <div className="place-table-wrapper">
            <Card>
                <Card.Section>
                    <Filters filters={[]} />
                </Card.Section>

                <Card.Section flush>
                    <IndexTable
                        loading={true}
                        headings={headings}
                        itemCount={90}
                        selectable={true}
                    >
                        {/* {Array.from({ length: 90 }, (_, i) => (
              <IndexTable.Row key={i}>
                {Array.from({ length: headings.length }, (_, i) => (
                  <IndexTable.Cell>
                    {i == 0 ? (
                      <SkeletonDisplayText size="small" />
                    ) : (
                      <SkeletonBodyText lines={2} />
                    )}
                  </IndexTable.Cell>
                ))}
              </IndexTable.Row>
            ))} */}

                        <tr style={{ height: "var(--p-space-4)" }}></tr>
                    </IndexTable>
                </Card.Section>
            </Card>
        </div>
    );
}